import React, { useState, useEffect } from 'react'
import './MobileNavbarCss.css'
import { useNavigate, useLocation } from 'react-router-dom'

const MobileNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [activeDropdown, setActiveDropdown] = useState(null)
  const navigate = useNavigate()
  const location = useLocation()

  const handleToggle = (key) => {
    setActiveDropdown(activeDropdown === key ? null : key)
  }

  useEffect(() => {
    if (location.pathname.startsWith('/RegularLeaveApplication') || location.pathname.startsWith('/MessLeaveApplication') || location.pathname.startsWith('/EventLeaveApplication')) {
      setActiveDropdown('leave')
    } else if (location.pathname.startsWith('/Eventstudent') || location.pathname.startsWith('/MyAttendance')) {
      setActiveDropdown('event')
    } else if (location.pathname.startsWith('/StudentTodaysMenu') || location.pathname.startsWith('/BreakFastReq') || location.pathname.startsWith('/MessAttendance') || location.pathname.startsWith('/MessFeedback')) {
      setActiveDropdown('mess')
    }
  }, [location])

  const handleNav = (path) => {
    navigate(path)
    setMenuOpen(false)
  }


const handleBack = () => {
  if (document.referrer) {
    navigate(-1)
  } else {
    navigate('/Homestudent')
  }
}



  return (
    <div className="mobile-navbar">
      <div className="mobile-navbar-header pb-2">
       <i className="fa fa-arrow-left back-icon" style={{color:"#fff",cursor:"pointer",fontSize:"20px"}} onClick={handleBack}></i>
        {/* <span className="title">WELCOME</span> */}
        <i className="fa fa-bars menu-icon" onClick={() => setMenuOpen(!menuOpen)}></i>
      </div>

      {menuOpen && (
        <div className="mobile-navbar-menu">
          <a onClick={() => handleNav('/Homestudent')}>Dashboard</a>
          <a onClick={() => handleNav('/DownloadReceipt')}>Payments</a>
          <a onClick={() => handleNav('/complainstudent')}>Complaints</a>

          <div className="dropdown">
            <div onClick={() => handleToggle('leave')} className="dropdown-title">
              Leave Application <span>{activeDropdown === 'leave' ? '▲' : '▼'}</span>
            </div>
            {activeDropdown === 'leave' && (
              <div className="dropdown-content">
                <a onClick={() => handleNav('/RegularLeaveApplication')}>Regular Leave</a>
                <a onClick={() => handleNav('/MessLeaveApplication')}>Meals Leave</a>
                <a onClick={() => handleNav('/EventLeaveApplication')}>Event Leave</a>
              </div>
            )}
          </div>

          <div className="dropdown">
            <div onClick={() => handleToggle('event')} className="dropdown-title">
              Event <span>{activeDropdown === 'event' ? '▲' : '▼'}</span>
            </div>
            {activeDropdown === 'event' && (
              <div className="dropdown-content">
                <a onClick={() => handleNav('/Eventstudent')}>Event Calendar</a>
                <a onClick={() => handleNav('/MyAttendance')}>My Attendance</a>
              </div>
            )}
          </div>

          <div className="dropdown">
            <div onClick={() => handleToggle('mess')} className="dropdown-title">
              Mess <span>{activeDropdown === 'mess' ? '▲' : '▼'}</span>
            </div>
            {activeDropdown === 'mess' && (
              <div className="dropdown-content">
                <a onClick={() => handleNav('/StudentTodaysMenu')}>Today's Menu</a>
                <a onClick={() => handleNav('/BreakFastReq')}>Breakfast Request</a>
                <a onClick={() => handleNav('/MessAttendance')}>Mess Attendance</a>
                <a onClick={() => handleNav('/MessFeedback')}>Feedback</a>
              </div>
            )}
          </div>

          <a onClick={() => handleNav('/Jobsstudent')}>Job</a>
          <a onClick={() => handleNav('/SuggestionStudent')}>Suggestion</a>
          <a onClick={() => handleNav('/StudentDischarge')}>Discharge</a>
        </div>
      )}
    </div>
  )
}

export default MobileNavbar
